import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { useTiclickTableContext } from '@src/design-system/molecules/ticlick-table/context/ticlick-table-context-hook';
import { Textfield } from '@src/shared/fields/text-field';
import { SavedViewsSelect } from '@src/shared/features/views/components/saved-views-select';
import type { TLead } from '@shared/types/lead';

import type { TCreateReminderFormValues } from '../schema';
import { SelectedLeadsPopover } from './selected-leads-popover';

function toLeadIdsKey(ids: number[]) {
  return [...ids].sort((a, b) => a - b).join(',');
}

export function LeadsAudienceSection() {
  const { table } = useTiclickTableContext<TLead>();
  const { setFieldValue } = useFormikContext<TCreateReminderFormValues>();

  const selectedLeads = table
    .getSelectedRowModel()
    .rows.flat()
    .map((row) => row.original as TLead);

  const selectedLeadIdsKey = toLeadIdsKey(selectedLeads.map((lead) => lead.id));

  useEffect(() => {
    const nextIds = selectedLeadIdsKey
      ? selectedLeadIdsKey.split(',').map(Number)
      : [];

    setFieldValue('selectedLeadIds', nextIds, false);
  }, [selectedLeadIdsKey, setFieldValue]);

  const hasPreselectedLeads = selectedLeads.length > 0;

  return (
    <section className='rounded-xl border border-[#E8E7F0] bg-white p-4'>
      <p className='mb-4 text-sm font-semibold text-gray-500'>
        1. Audience Details
      </p>

      <div className='flex flex-col gap-4'>
        <Textfield
          label='Reminder name'
          name='name'
          placeholder='Enter Reminder Name'
        />

        {hasPreselectedLeads ? (
          <SelectedLeadsPopover />
        ) : (
          <SavedViewsSelect entity_type='LEAD' />
        )}
      </div>
    </section>
  );
}
